import {Component, OnInit} from '@angular/core';
import {Office} from '../../../classes/Office';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {OfficeService} from '../../../services/office.service';
import {FormGroup} from '@angular/forms';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {RoomClosure} from '../../../classes/RoomClosure';
import {RoomClosureService} from '../../../services/roomclosure.service';
import {RoomClosureEditComponent} from '../roomclosure-edit/roomclosure-edit.component';

@Component({
  selector: 'app-roomclosure-list',
  styleUrls: ['./roomclosure-list.component.scss'],
  templateUrl: './roomclosure-list.component.html',
})
export class RoomClosureListComponent implements OnInit {

  public roomClosures: RoomClosure[];
  public errorMessage: string;
  private currentDialog = null;
  private offices: Map<number, Office>;

  constructor(private roomClosureService: RoomClosureService,
              private modalService: NgbModal,
              private officeService: OfficeService) {
  }

  ngOnInit(): void {
    this.updateList();

    this.officeService.getAll()
      .subscribe((response: Office[]) => this.offices = new Map(response.map(office => [office.id, office])));
  }

  private updateList(): void {
    this.roomClosureService.getAll()
      .subscribe({
        next: (response: RoomClosure[]) => this.roomClosures = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(roomClosure: RoomClosure): void {
    this.currentDialog = this.modalService.open(RoomClosureEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-roomclosure-edit',
        size: 'xl',
        centered: true,
      });

    this.currentDialog.componentInstance.roomClosure = roomClosure;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          this.roomClosureService.addOrEdit({
              id: result.controls.id.value,
              roomId: result.controls.roomId.value,
              start: new Date(result.controls.start.value).toISOString(),
              end: new Date(result.controls.end.value).toISOString()
          }).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(roomClosure: RoomClosure): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete room closure ' + roomClosure.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.roomClosureService.delete(roomClosure.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  getOffice(officeId: number): string {
    const office = this.offices.get(officeId);
    return office.city + ', ' + office.address;
  }
}
